import { colors } from '@theme/colors';

import { PaletteOptions } from '@mui/material';
import { SystemMode } from '@mui/system/cssVars/useCurrentColorScheme';

export const themePalette = (mode: SystemMode = 'light'): PaletteOptions => ({
  mode,
  common: {
    black: colors.darkPaper,
  },
  primary: {
    light: mode === 'dark' ? colors.darkPrimaryLight : colors.primaryLight,
    main: mode === 'dark' ? colors.darkPrimaryMain : colors.primaryMain,
    dark: mode === 'dark' ? colors.darkPrimaryDark : colors.primaryDark,
    200: mode === 'dark' ? colors.darkPrimary200 : colors.primary200,
    800: mode === 'dark' ? colors.darkPrimary800 : colors.primary800,
  },
  secondary: {
    light: mode === 'dark' ? colors.darkSecondaryLight : colors.secondaryLight,
    main: mode === 'dark' ? colors.darkSecondaryMain : colors.secondaryMain,
    dark: mode === 'dark' ? colors.darkSecondaryDark : colors.secondaryDark,
    200: mode === 'dark' ? colors.darkSecondary200 : colors.secondary200,
    800: mode === 'dark' ? colors.darkSecondary800 : colors.secondary800,
  },
  error: {
    light: colors.errorLight,
    main: colors.errorMain,
    dark: colors.errorDark,
  },
  orange: {
    light: colors.orangeLight,
    main: colors.orangeMain,
    dark: colors.orangeDark,
  },
  warning: {
    light: colors.warningLight,
    main: colors.warningMain,
    dark: colors.warningDark,
  },
  success: {
    light: colors.successLight,
    200: colors.success200,
    main: colors.successMain,
    dark: colors.successDark,
  },
  grey: {
    50: colors.grey50,
    100: colors.grey100,
    500: colors.grey500,
    600: colors.grey900,
    700: colors.grey700,
    900: colors.grey900,
  },
  dark: {
    light: colors.darkTextPrimary,
    main: colors.darkLevel1,
    dark: colors.darkLevel2,
    800: colors.darkBackground,
    900: colors.darkPaper,
  },
  text: {
    primary: colors.grey700,
    secondary: colors.grey500,
    dark: colors.grey900,
    hint: colors.grey100,
  },
  background: {
    paper: colors.paper,
    default: colors.paper,
  },
});
